import { Box, TextInput, TextInputProps } from '@mantine/core';
import { forwardRef, useEffect } from 'react';
import { useFocusWithin, useMergedRef } from '@mantine/hooks';

import InputLabel from 'components/input-label';
import classes from './index.module.css';

interface ICustomTextInput extends TextInputProps {
  info?: string;
  label?: string;
  variant?: string;
  labelLight?: boolean;
  onInputFocus?: any;
}

const CustomTextInput = forwardRef<HTMLInputElement, ICustomTextInput>(
  (
    {
      info,
      label,
      required,
      variant = '',
      labelLight = false,
      onInputFocus,
      ...props
    },
    ref
  ) => {
    const { ref: focusRef, focused } = useFocusWithin();

    const mergedRef = useMergedRef(ref, focusRef);

    useEffect(() => {
      if (focused) {
        onInputFocus?.(true);
      }
    }, [focused, onInputFocus]);

    return (
      <Box>
        {label && (
          <InputLabel
            label={label}
            light={labelLight}
            required={required}
            info={info}
          />
        )}

        <TextInput
          {...props}
          ref={mergedRef}
          classNames={{
            wrapper: classes.wrapper,
            input: `${classes.input} ${classes[variant]} ${
              focused ? classes.focused : ''
            }`,
          }}
          mb={6}
          withAsterisk={required}
        />
      </Box>
    );
  }
);

export default CustomTextInput;
